<template>
	<div v-if="airarsdlrlShow">
		<div class="fadein_bind RARSDLRL">
			<div class="box" style="width: 840px;">
				<div class="head">
					<p>{{$t('aipf')}}</p>
					<img src="@/assets/images/close_03.png" @click="back" class="close" />
				</div>
				<div class="airank">
					<div class="item">
						<p>{{$t('bencily')}}</p>
						<audio :src="aiData.audioUrl" controls="controls"></audio>
					</div>
					<div class="item">
						<p>{{$t('bencipf')}}</p>
						<div class="total">
							<div class="icons">
								<div class="find">
									<p>{{aiData.score}}</p>
									<span>Total</span>
								</div>
							</div>
							<div class="frs">
								<div class="jds">
									<div class="icon">
										<span>{{$t('liulidu')}} </span>
										<img src="@/assets/images/whs_03.png"  @click="showFluency()"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.scoreInfo.fluency/aiData.scoreInfo.fluencyTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.scoreInfo.fluency}}<i>/{{aiData.scoreInfo.fluencyTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('neirong')}}</span>
										<img src="@/assets/images/whs_03.png"  @click="showContent()"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.scoreInfo.content/aiData.scoreInfo.contentTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.scoreInfo.content}}<i>/{{aiData.scoreInfo.contentTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('fayin')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showPron()" />
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.scoreInfo.pronunciation/aiData.scoreInfo.pronunciationTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.scoreInfo.pronunciation}}<i>/{{aiData.scoreInfo.pronunciationTotal}}</i></em></span>
								</div>
							</div>
						</div>
					</div>
					<!--<div class="item">
						<p>口语能力分析</p>
						<div class="kyfx">
							<div class="lab">
								<div class="jds">
									<div class="icon">
										<span>发音准确性</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<div class="jd">
										<div style="width: 60%;"></div>
									</div>
									<span><em>31%</em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>流畅度</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<div class="jd">
										<div style="width: 60%;"></div>
									</div>
									<span><em>31%</em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>语调起伏</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<div class="jd">
										<div style="width: 60%;"></div>
									</div>
									<span><em>31%</em></span>
								</div>
							</div>
							<div class="lab">
								<div class="jds">
									<div class="icon">
										<span>重弱读</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<div class="jd">
										<div style="width: 60%;"></div>
									</div>
									<span><em>31%</em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>语速均匀度</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<div class="jd">
										<div style="width: 60%;"></div>
									</div>
									<span><em>31%</em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>单词语速</span>
										<img src="@/assets/images/whs_03.png" />
									</div>
									<div class="jd">
										<div style="width: 60%;"></div>
									</div>
									<span><em>31%</em></span>
								</div>
							</div>
						</div>
					</div>-->
					<div class="item">
						<div class="h">
							<p>{{$t('fayininfo')}} <span style="color:red;font-weight: bold;" v-if="aiData.scoreInfo.speed&&aiData.scoreInfo.speed<=85">{{$t('speedtoslow')}}</span> <span style="color:red;font-weight: bold;" v-if="aiData.scoreInfo.speed&&aiData.scoreInfo.speed>=120">{{$t('speedtofast')}}</span></p>
							<ul>
								<li>
									<div></div>
									<span>{{$t('status1')}}</span>
								</li>
								<li>
									<div></div>
									<span>{{$t('status2')}}</span>
								</li>
								<li>
									<div></div>
									<span>{{$t('status3')}}</span>
								</li>
								<li>
									<div></div>
									<span>{{$t('status4')}}</span>
								</li>
							</ul>
						</div>
						<div class="contents" v-html="arrHtml"></div>
					</div>
					<div class="button" style="margin-top: 28px;">
						<div class="on" @click="back">{{$t('back')}}</div>
						<div @click="back">{{$t('queding')}}</div>
						<div class="danger" @click="submitToTeacher">{{$t('submittoteacher')}}</div>
					</div>
				</div>
			</div>
		</div>
		<AiDesc :descFont="descFont"></AiDesc>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'airarsdlrlShow',
		props: ['aiData','aiData1'],
		data() {
			return {
				arrHtml: '',
				showbox: true,
				descFont: {}
			}
		},
		watch: {
			aiData(newValue, oldValue) {
				let arrHtml = ''
				if(newValue.scoreInfo&&newValue.scoreInfo.words) {
					newValue.scoreInfo.words.forEach((item) => {
						if(item.pronunciation >= 70 && item.pronunciation < 90) {
							arrHtml += `<span style="color: #8377f4">${item.word}</span> `
						}
						if(item.pronunciation >= 54 && item.pronunciation < 70) {
							arrHtml += `<span style="color: #fead4b">${item.word}</span> `
						}
						if(item.pronunciation < 54) {
							arrHtml += `<span style="color: #e60053">${item.word}</span> `
						} else {
							arrHtml += `<span>${item.word}</span> `
						}
					})
				}else if(newValue.words){
					newValue.words.forEach((item) => {
						if(item.pronunciation >= 70 && item.pronunciation < 90) {
							arrHtml += `<span style="color: #8377f4">${item.word}</span> `
						}
						if(item.pronunciation >= 54 && item.pronunciation < 70) {
							arrHtml += `<span style="color: #fead4b">${item.word}</span> `
						}
						if(item.pronunciation < 54) {
							arrHtml += `<span style="color: #e60053">${item.word}</span> `
						} else {
							arrHtml += `<span>${item.word}</span> `
						}
					})
				}
				this.arrHtml = arrHtml
			},
		},
		mounted() {

		},
		computed: {
			airarsdlrlShow() {
				return this.$store.state.airarsdlrlShow;
			}
		},
		methods: {
			s() {
				console.log(this.aiData)
			},
			back() {
				this.$store.commit("showairarsdlrlShow", false);
			},
			showFluency(){
				this.descFont = {
					title: this.$i18n.t('liulidu'),
					desc: this.$i18n.t('liulidudesc')
				}
				this.$store.commit("showaiDESCShow", true);
			},
			showContent(){
				this.descFont = {
					title: this.$i18n.t('neirong'),
					desc: this.$i18n.t('neirongdesc')
				}
				this.$store.commit("showaiDESCShow", true);
			},
			showPron(){
				this.descFont = {
					title: this.$i18n.t('fayin'),
					desc: this.$i18n.t('fayindesc')
				}
				this.$store.commit("showaiDESCShow", true);
			},
			submitToTeacher(){
				
			},
		},
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ai-RARSDLRL.vue